/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md:
   this file exports a function, not a React component. */
export function formatPaginationPageText({
  pageIndex,
  pageSize,
  rowCount,
  totalCount,
}: {
  pageIndex: number;
  pageSize: number;
  rowCount: number | undefined;
  totalCount: number | undefined;
}): string | null {
  if (rowCount === 0) {
    return null;
  }
  const pageCount = totalCount !== undefined ? Math.ceil(totalCount / pageSize) : undefined;
  return pageCount !== undefined && pageCount > 0
    ? `Page ${(pageIndex + 1).toLocaleString()} of ${pageCount.toLocaleString()}`
    : `Page ${(pageIndex + 1).toLocaleString()}`;
}
